import { render } from "./Telechargements.vue?vue&type=template&id=3f07f6f5"
import script from "./Telechargements.vue?vue&type=script&lang=js"
export * from "./Telechargements.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phl/phlsupport/deploy-support-cli/front_vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__